<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="success" @click="toWj" v-if="$permission.can('读','/st/wj')">违纪处理</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="60">
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.StayQualification==0" @click="edit(row)">恢复</el-button>
            <el-button type="text" v-else @click="edit(row)">取消</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="toReload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/attendance/qualification/list";
import editDialog from "@/components/attendance/qualification/editDialog";

export default {
  name: "qualification",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    reload() {},
    toWj() {
      this.$router.push({ path: "/st/wj" })
    },
    toReload() {
      this.$refs.list.query();
    },
    onExport() {
      this.$refs.list.onExport();
    },
  },
};
</script>